import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloLink,
} from "@apollo/client";

// Every GraphQL call is a POST to the same URI, so RUM's HTTP telemetry and the
// API access log would otherwise show an undifferentiated wall of
// "POST /api/graphql". Naming the operation on the request makes both readable.
// The API echoes it back into its structured logs — see
// libs/observability/access-log.js.
const operationNameLink = new ApolloLink((operation, forward) => {
  if (operation.operationName) {
    operation.setContext(({ headers = {} }) => ({
      headers: { ...headers, "x-graphql-operation": operation.operationName },
    }));
  }
  return forward(operation);
});

export const get = (apiRoute) => {
  const link = createHttpLink({
    uri: apiRoute,
    credentials: "include",
  });

  const client = new ApolloClient({
    link: ApolloLink.from([operationNameLink, link]),
    cache: new InMemoryCache(),
  });
  return client;
};
